import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { parse, format as dateFnsFormat } from 'date-fns';

/** Adapts the native JS Date for use with cdk-based components that work with dates. */
@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  readonly DT_FORMAT = 'dd/MM/yyyy';
 
  override getFirstDayOfWeek(): number {    
    return 1;
  }
  override parse(value: string | null): Date | null {
    if (value) {
      value = value.trim();
      if(!value.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
        return new Date(NaN);
      }
      return parse(value, this.DT_FORMAT, new Date())
    }
    return null;
  }
  override format(date: Date): string {
    return dateFnsFormat(date, this.DT_FORMAT)
  }
}
